import script from "./chart2.vue?vue&type=script&setup=true&name=Analysis&lang=js"
export * from "./chart2.vue?vue&type=script&setup=true&name=Analysis&lang=js"

const __exports__ = script;

export default __exports__